import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from './logo-space.png'
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);
  const mapUrl = "https://www.google.com/maps/search/?api=1&query=F-35%2F2c%2C%20Central%20Market%2C%20Kirti%20Nagar%2C%20New%20Delhi%20110015";

  return (
    <div className="card-container pt-5">
      <Tilt glareEnable={true} glareMaxOpacity={0.25} scale={1.05} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-white"><img src={logo} width='60' height='auto' alt="" />  </div>      SPACE ORGANICS
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
               
                  
                
                <div>
                  <h5 className="card-name mb-1">Bhupinder Nagpal</h5>
                  <p className="card-role mb-1">Owner</p>
                  <p className="card-phone mb-0">+91 98914 82214</p>
                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
FN:Bhupinder Nagpal
ORG:Space Organics
TITLE:Owner
TEL;TYPE=CELL:+919891482214
TEL;TYPE=WORK:+919312656002
EMAIL:spaceorganics@yahoo.in
URL:https://spaceorganics.co.in
ADR;TYPE=WORK:;;F-35/2c, Central Market, Kirti Nagar;New Delhi;;110015;India
NOTE:Factory Address: 1900, Hsiidc, Industrial Area, Rai, Sonepat-131029 (Haryana)
END:VCARD`}
                  size={80}
                  fgColor="#000000"
                />
               
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              F-35/2c, Central Market, Kirti Nagar, <br />
              New Delhi - 110015
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 bg-white"><img src={logo} width='60' height='auto' alt="" />  </div>      SPACE ORGANICS
            </h5>

            <div className="address mt-3 small text-muted">
              <div>
                <i className="fa fa-map-marker me-2"></i>
                Office: F-35/2c, Central Market, Kirti Nagar, New Delhi - 110015
              </div>
              <div className="mt-2">
                <i className="fa fa-map-marker me-2"></i>  Factory: 1900, Hsiidc, Industrial Area, Rai, Sonepat - 131029 (Haryana)
              </div>
            
            </div>
            {/* <div className="qr-box ">
              <QRCodeSVG
                value={mapUrl}
                size={60}
                fgColor="#000000"
              />
            </div> */}
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div className="d-flex flex-column gap-3 mt-5 w-75 mx-auto" style={{ maxWidth: "280px" }}>
        <a href="/Bhupinder-Nagpal.vcf" download className="platinum-btn">Add To Contacts</a>
        <a href="tel:+919891482214" className="platinum-btn">Call Now</a>
        <a href="mailto:spaceorganics@yahoo.in" className="platinum-btn">Email Us</a>
        <a href="https://wa.me/919891482214" target="_blank" rel="noopener noreferrer" className="platinum-btn">
  WhatsApp
</a>

        <a href="https://spaceorganics.co.in" target="_blank" rel="noopener noreferrer" className="platinum-btn">Website</a>
        <a href={mapUrl} target="_blank" rel="noopener noreferrer" className="platinum-btn">Address Details</a>
        {/* <a href="/brochure.pdf" download className="platinum-btn">Brochure</a> */}
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
